import { useSelector } from "react-redux";

const useGetCXAppLink = () => {
  const config = useSelector((state) => state.configReducer);
  return config.whatsAppMsg ? config.whatsAppMsg.msg : "";
};

export default useGetCXAppLink;
